/**
 * @name crud_marketing_indicacoes.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\crud_marketing_indicacoes.js
 */

const XLSX = require('xlsx');

import TableBuilder from './table_builder.js';
import Swal from 'sweetalert2';

var getBaseDir = null, apiCall = null, escapeSingleQuotes = null, userHasRole = null;

$(function () {
    let self = this;

    import('./utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        escapeSingleQuotes = utils.escapeSingleQuotes;
        userHasRole = utils.userHasRole;

        if (!utils.isUserLoggedIn())
            return;

        if (location.pathname !== utils.getBaseDir() + 'marketing/indicacoes')
            return;

        window.MarketingIndicacoesClass = new MarketingIndicacoes();
    });
});

class MarketingIndicacoes {
    constructor() {
        this.indicacoesList = [];
        this.selectedIndicacao = null;

        // Filtros ativos
        this.filterFilialId = '';
        this.filterDataInicio = '';
        this.filterDataFim = '';

        let self = this;

        // Initialize Table Builder
        this.tableHandler = new TableBuilder({
            table: '#table-marketing-indicacoes',
            tableBody: '.js-marketing-indicacoes-list',
            data: [],
            rowsPerPage: 25,
            filter: false,
            maxPages: 0,
            customId: "CrudMarketingIndicacoesHandler",
            tableRowRenderer: function (rowData) {
                return self.mountTableRow(rowData);
            },
            OnClickFirstPage: function () {
                self.fetchIndicacoesList();
            },
            OnClickLastPage: function () {
                self.fetchIndicacoesList();
            },
            OnTableRendered: function () {
                window.reloadIconss();
            }
        });

        this.bindDomEvents();
        this.fetchIndicacoesList();
        this.fetchBranches();
        this.initSelect2();
    }

    bindDomEvents() {
        let self = this;

        // ---- Filtros ----

        // Botão Filtrar
        $(document).on('click', '.js-indicacoes-filter-btn', function () {
            self.applyFilters();
        });

        // Auto-filtro ao mudar filial
        $(document).on('change', '#filter_indicacao_filial_id', function () {
            self.applyFilters();
        });

        // Auto-filtro ao mudar datas
        $(document).on('change', '#filter_indicacao_data_inicio, #filter_indicacao_data_fim', function () {
            self.applyFilters();
        });

        // Botão Limpar filtros
        $(document).on('click', '.js-indicacoes-filter-clear-btn', function () {
            self.filterFilialId = '';
            self.filterDataInicio = '';
            self.filterDataFim = '';
            // Limpa os campos sem disparar o auto-filtro novamente
            $('#filter_indicacao_filial_id').val('');
            $('#filter_indicacao_data_inicio').val('');
            $('#filter_indicacao_data_fim').val('');
            self.tableHandler.setCurrentPage(1);
            self.fetchIndicacoesList();
        });

        // Exportar PDF
        $(document).on('click', '.js-export-indicacoes-pdf-btn', function () {
            self.exportPdf();
        });

        // Exportar Excel
        $(document).on('click', '.js-export-indicacoes-excel-btn', function () {
            self.exportExcel();
        });

        // ---- Insert Indicacao form ----
        $(document).on('submit', '.js-insert-indicacao-form', function (e) {
            e.preventDefault();
            let serializeData = $(this).serializeArray();
            let formBtn = $(this).find('button[type="submit"]');

            formBtn.prop('disabled', true);
            $(".js-insert-indicacao-form").block(window._loader.loading);

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/marketing/indicacoes',
                data: serializeData,
                successCallback: function (res) {
                    formBtn.prop('disabled', false);
                    $(".js-insert-indicacao-form").unblock();

                    window.toast({
                        error: res.error,
                        text: res.message
                    });

                    if (!res.error) {
                        $('.js-insert-indicacao-form').trigger('reset');
                        $('#insert_indicacao_cliente_indicou_id').val(null).trigger('change');
                        $('#modal-insert-indicacao').modal('hide');
                        self.fetchIndicacoesList();
                    }
                },
                errorCallback: function (err) {
                    formBtn.prop('disabled', false);
                    $(".js-insert-indicacao-form").unblock();
                    window.toast({ error: true, text: 'Erro ao conectar-se.' });
                }
            });
        });

        // Edit Indicacao Button Click
        $(document).on('click', '.js-edit-indicacao-btn', function () {
            let rowData = $(this).data('info');
            self.selectedIndicacao = rowData;

            $('#edit_indicacao_id').val(rowData.ID);
            $('#edit_indicacao_filial_id').val(rowData.FILIAL_ID);
            $('#edit_indicacao_data').val(rowData.DATA_INDICACAO);
            $('#edit_indicacao_primeiro_nome').val(rowData.PRIMEIRO_NOME);
            $('#edit_indicacao_sobrenome').val(rowData.SOBRENOME);
            $('#edit_indicacao_telefone').val(rowData.TELEFONE);

            if (rowData.CLIENTE_INDICOU_ID) {
                var option = new Option(`ID ${rowData.CLIENTE_INDICOU_ID}`, rowData.CLIENTE_INDICOU_ID, true, true);
                $('#edit_indicacao_cliente_indicou_id').append(option).trigger('change');
            } else {
                $('#edit_indicacao_cliente_indicou_id').val(null).trigger('change');
            }

            $('#modal-edit-indicacao').modal('show');
            window.reloadMasks();
        });

        // Edit form submit
        $(document).on('submit', '.js-edit-indicacao-form', function (e) {
            e.preventDefault();
            let serializeData = $(this).serializeArray();
            let formBtn = $(this).find('button[type="submit"]');

            formBtn.prop('disabled', true);
            $(".js-edit-indicacao-form").block(window._loader.loading);

            apiCall({
                method: 'PUT',
                endpoint: 'api/v1/marketing/indicacoes',
                data: serializeData,
                successCallback: function (res) {
                    formBtn.prop('disabled', false);
                    $(".js-edit-indicacao-form").unblock();

                    window.toast({
                        error: res.error,
                        text: res.message
                    });

                    if (!res.error) {
                        $('.js-edit-indicacao-form').trigger('reset');
                        $('#edit_indicacao_cliente_indicou_id').val(null).trigger('change');
                        $('#modal-edit-indicacao').modal('hide');
                        self.fetchIndicacoesList();
                    }
                },
                errorCallback: function (err) {
                    formBtn.prop('disabled', false);
                    $(".js-edit-indicacao-form").unblock();
                    window.toast({ error: true, text: 'Erro ao conectar-se.' });
                }
            });
        });

        // Delete Indicacao Button Click
        $(document).on('click', '.js-delete-indicacao-btn', function () {
            let rowData = $(this).data('info');

            Swal.fire({
                title: 'Confirmação',
                text: 'Deseja realmente excluir esta indicação?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.isConfirmed) {
                    apiCall({
                        method: 'DELETE',
                        endpoint: 'api/v1/marketing/indicacoes',
                        data: { id: rowData.ID },
                        successCallback: function (res) {
                            window.toast({ error: res.error, text: res.message });
                            if (!res.error) {
                                self.fetchIndicacoesList();
                            }
                        }
                    });
                }
            });
        });
    }

    initSelect2() {
        let self = this;

        let select2AjaxConfig = function (branchSelector) {
            return {
                url: getBaseDir() + 'api/v1/patient/search',
                delay: 1000,
                data: function (params) {
                    return {
                        search: params.term,
                        branchId: $(branchSelector).val() || -1,
                        page: params.page || 1,
                        allContracts: true
                    };
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;
                    var results = [];
                    $.each(data.results, function (k, v) {
                        results.push({
                            id: v.ID,
                            text: `${v.ID} - ${v.TEXT} - ${v.CADASTRO_COMPLETO == 'N' ? 'Sem CPF' : v.CPF}${v.CONTRATO_ID != null ? ` - C${v.CONTRATO_ID} (${v.SESSOES_REALIZADAS}/${v.TOTAL_SESSOES})` : ' - Sem Contrato'}`,
                            info: v
                        });
                    });
                    return {
                        results: results,
                        pagination: {
                            more: (params.page * 10) < data.count_filtered
                        }
                    };
                }
            };
        };

        $('#insert_indicacao_cliente_indicou_id').select2({
            placeholder: "Busque por telefone, nome ou email",
            theme: 'bootstrap-5',
            minimumInputLength: 3,
            allowClear: true,
            dropdownParent: $("#modal-insert-indicacao"),
            ajax: select2AjaxConfig('#insert_indicacao_filial_id')
        });

        $('#edit_indicacao_cliente_indicou_id').select2({
            placeholder: "Busque por telefone, nome ou email",
            theme: 'bootstrap-5',
            minimumInputLength: 3,
            allowClear: true,
            dropdownParent: $("#modal-edit-indicacao"),
            ajax: select2AjaxConfig('#edit_indicacao_filial_id')
        });
    }

    fetchBranches() {
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/business/branches',
            successCallback: function (res) {
                if (!res.error) {
                    let html = '<option value="">Selecione...</option>';
                    for (let i in res.data) {
                        let branchObj = res.data[i];
                        html += `<option value="${branchObj.ID}">${branchObj.FILIAL}</option>`;
                    }
                    $('.js-branches-selector').html(html);
                }
            }
        });
    }

    /**
     * Lê os campos de filtro do DOM, atualiza as props e recarrega a lista.
     * Chamado tanto pelo botão "Filtrar" quanto pelos eventos de change automáticos.
     */
    applyFilters() {
        this.filterFilialId   = $('#filter_indicacao_filial_id').val()        || '';
        this.filterDataInicio = $('#filter_indicacao_data_inicio').val()       || '';
        this.filterDataFim    = $('#filter_indicacao_data_fim').val()          || '';
        this.tableHandler.setCurrentPage(1);
        this.fetchIndicacoesList();
    }

    fetchIndicacoesList() {
        let self = this;

        let requestData = {
            start: (this.tableHandler.getCurrentPage() - 1) * this.tableHandler.rowsPerPage,
            length: this.tableHandler.rowsPerPage,
            search: { value: '' }
        };

        // Aplicar filtros ativos
        if (this.filterFilialId !== '') {
            requestData.filial_id = this.filterFilialId;
        }
        if (this.filterDataInicio !== '') {
            requestData.data_inicio = this.filterDataInicio;
        }
        if (this.filterDataFim !== '') {
            requestData.data_fim = this.filterDataFim;
        }

        apiCall({
            method: 'GET',
            endpoint: 'api/v1/marketing/indicacoes',
            data: requestData,
            successCallback: function (res) {
                if (res.error) return;

                self.indicacoesList = res.aaData;
                self.tableHandler.renderPage(self.tableHandler.getCurrentPage(), false, self.indicacoesList, false, res.iTotalRecords);
            },
            errorCallback: function (err) {
                // silently fail
            }
        });
    }

    /**
     * Exporta a lista atual de indicações para PDF usando jsPDF + autoTable.
     * Respeita os filtros ativos (filial e datas).
     */
    exportPdf() {
        let self = this;

        if (!self.indicacoesList || self.indicacoesList.length === 0) {
            window.toast({ error: true, text: 'Nenhum dado para exportar. Aplique os filtros e carregue a lista primeiro.' });
            return;
        }

        const { jsPDF } = window.jspdf;
        const doc = new jsPDF('landscape');

        // Logo base64 (Ajustar)
        const imgData = 'data:image/png;base64,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';

        const logo = new Image();
        logo.src = imgData;
        logo.onload = function () {
            const logoWidth = 25;
            const logoHeight = (logo.height * logoWidth) / logo.width;
            doc.addImage(logo, 'PNG', 5, 5, logoWidth, logoHeight);

            const pageWidth = doc.internal.pageSize.getWidth();

            // Título
            doc.setFontSize(14);
            let titleText = 'Relatório de Indicações';
            let textWidth = doc.getTextWidth(titleText);
            doc.text(titleText, (pageWidth - textWidth) / 2, 10);

            // Subtítulo — período
            doc.setFontSize(10);
            let periodoText = '';
            if (self.filterDataInicio && self.filterDataFim) {
                periodoText = `Período: ${self.filterDataInicio.split('-').reverse().join('/')} até ${self.filterDataFim.split('-').reverse().join('/')}`;
            } else if (self.filterDataInicio) {
                periodoText = `A partir de: ${self.filterDataInicio.split('-').reverse().join('/')}`;
            } else if (self.filterDataFim) {
                periodoText = `Até: ${self.filterDataFim.split('-').reverse().join('/')}`;
            } else {
                periodoText = 'Período: Todos';
            }
            textWidth = doc.getTextWidth(periodoText);
            doc.text(periodoText, (pageWidth - textWidth) / 2, 16);

            // Filial selecionada
            let filialText = '';
            if (self.filterFilialId !== '') {
                let filialNome = $('#filter_indicacao_filial_id option:selected').text();
                filialText = `Filial: ${filialNome}`;
            } else {
                filialText = 'Filial: Todas';
            }
            textWidth = doc.getTextWidth(filialText);
            doc.text(filialText, (pageWidth - textWidth) / 2, 21);

            // Data de geração
            let now = new Date();
            let geradoText = `Gerado em: ${now.toLocaleString('pt-BR')}`;
            textWidth = doc.getTextWidth(geradoText);
            doc.text(geradoText, (pageWidth - textWidth) / 2, 26);

            // Montar cabeçalho e dados da tabela manualmente
            const head = [['#', 'Filial', 'Data', 'Primeiro Nome', 'Sobrenome', 'Telefone', 'Cadastrado por']];
            const body = self.indicacoesList.map(function (row) {
                return [
                    row.ID || '',
                    row.FILIAL_NOME || row.FILIAL_ID || '',
                    row.DATA_INDICACAO_FORMATTED || '',
                    row.PRIMEIRO_NOME || '',
                    row.SOBRENOME || '-',
                    row.TELEFONE || '',
                    `${row.USUARIO_LOGIN || ''}\n${row.USUARIO_DATA_FORMATTED || ''}`
                ];
            });

            doc.autoTable({
                head: head,
                body: body,
                startY: 30,
                theme: 'grid',
                styles: {
                    fontSize: 9,
                    cellPadding: 2
                },
                headStyles: {
                    fillColor: [41, 128, 185],
                    textColor: 255,
                    fontStyle: 'bold'
                },
                alternateRowStyles: {
                    fillColor: [240, 248, 255]
                },
                margin: { top: 2, right: 5, bottom: 5, left: 5 }
            });

            doc.save(`relatorio_indicacoes_${now.toISOString().slice(0, 10)}.pdf`);
        };
    }

    /**
     * Exporta a lista atual de indicações para Excel (.xlsx) usando SheetJS.
     * Respeita os filtros ativos (filial e datas).
     */
    exportExcel() {
        let self = this;

        if (!self.indicacoesList || self.indicacoesList.length === 0) {
            window.toast({ error: true, text: 'Nenhum dado para exportar. Aplique os filtros e carregue a lista primeiro.' });
            return;
        }

        // Mapear para colunas com nomes em português
        const data = self.indicacoesList.map(function (row) {
            return {
                'ID':              row.ID || '',
                'Filial':          row.FILIAL_NOME || row.FILIAL_ID || '',
                'Data Indicação':  row.DATA_INDICACAO_FORMATTED || '',
                'Primeiro Nome':   row.PRIMEIRO_NOME || '',
                'Sobrenome':       row.SOBRENOME || '',
                'Telefone':        row.TELEFONE || '',
                'Cadastrado por':  row.USUARIO_LOGIN || '',
                'Data Cadastro':   row.USUARIO_DATA_FORMATTED || ''
            };
        });

        const worksheet  = XLSX.utils.json_to_sheet(data);
        const workbook   = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Indicações');

        // Largura automática das colunas
        const colWidths = Object.keys(data[0]).map(key => ({
            wch: Math.max(key.length, ...data.map(row => String(row[key]).length)) + 2
        }));
        worksheet['!cols'] = colWidths;

        let now = new Date();
        let filialSuffix = self.filterFilialId !== ''
            ? '_' + ($('#filter_indicacao_filial_id option:selected').text().replace(/\s+/g, '_'))
            : '';

        XLSX.writeFile(workbook, `relatorio_indicacoes${filialSuffix}_${now.toISOString().slice(0, 10)}.xlsx`);
    }

    mountTableRow(rowData) {
        return `
            <tr>
                <td>#${rowData.ID}</td>
                <td>${rowData.FILIAL_NOME || rowData.FILIAL_ID || '-'}</td>
                <td>${rowData.DATA_INDICACAO_FORMATTED}</td>
                <td>${rowData.PRIMEIRO_NOME}</td>
                <td>${rowData.SOBRENOME || '-'}</td>
                <td><a href="https://wa.me/55${rowData.TELEFONE.replace(/\D/g, '')}" target="_blank" class="text-success" style="text-decoration:none;"><i class="fab fa-whatsapp"></i> ${rowData.TELEFONE}</a></td>
                <td>${rowData.USUARIO_LOGIN} <br> <small>${rowData.USUARIO_DATA_FORMATTED}</small></td>
                <td>
                    <button class="btn btn-sm btn-primary js-edit-indicacao-btn" data-info='${escapeSingleQuotes(JSON.stringify(rowData))}'><span data-feather="edit"></span></button>
                    <button class="btn btn-sm btn-danger js-delete-indicacao-btn" data-info='${escapeSingleQuotes(JSON.stringify(rowData))}'><span data-feather="trash"></span></button>
                </td>
            </tr>
        `;
    }
}
